/* eslint-disable no-underscore-dangle */
import Clone from 'clone';
import { diff, addedDiff, deletedDiff, updatedDiff, detailedDiff } from 'deep-object-diff';
import AuthService from '../../services/AuthService';
import router from '../../router';
import UtilsService from '../../services/UtilsService';
import axios from 'axios';

const getAppRolesEnum = (embeddedRoleEnumeration) => {
  const enumList = Object.keys(embeddedRoleEnumeration);
  const newRolesEnum = [];
  for (let i = 0; i < enumList.length; i += 1) {
    newRolesEnum.push({
      text: embeddedRoleEnumeration[enumList[i]],
      value: enumList[i],
    });
  }
  return newRolesEnum;
};

const user = {
  state: {
    userSession: null,
    userShowed: null,
    userProfileClone: {},
    userProfileCloneUpdated: false,
    userRolesClone: [],
    userRolesCloneUpdated: false,
    isActiveClone: null,
    users: null,
    rolesEnumeration: [
      { text: 'Agent', value: 'ROLE_AGENT' },
      { text: 'Admin', value: 'ROLE_ADMIN' },
      { text: 'Agence', value: 'ROLE_AGENCY' },
    ],
    profileModalShow: false,
    formRegisterError: [],
    formPatchUserError: [],
    formRolesUserError: [],
    showUserSelectModal: false,
  },
  mutations: {
    setUserShowed(state, data) {
      state.userShow = data;
    },
    setUserSession(state, data) {
      state.userSession = data;
    },
    setUserProfileClone(state, objectToClone) {
      state.userShowed = objectToClone;
      state.userProfileClone = Clone(objectToClone);
      state.userProfileCloneUpdated = false;
      state.formPatchUserError = {};
    },
    setUserProfileCloneUpdated(state, value) {
      state.userProfileCloneUpdated = value;
    },
    setUserRolesClone(state, value) {
      if (state.userRolesClone.length < 1) {
        state.userRolesClone = Clone(state.userProfileClone.roles);
      }
      state.userRolesClone = value;
      const rolesDiff = diff(state.userProfileClone.roles, state.userRolesClone);
      state.userRolesCloneUpdated = !UtilsService.isEmpty(rolesDiff);
    },
    setUserRolesCloneUpdated(state, value) {
      state.userRolesCloneUpdated = value;
    },
    setUserProfileCloneProperty(state, value) {
      // Must create clone before, because watchers does not trigger if same object
      let newUserClone = {};
      newUserClone = Clone(state.userProfileClone);
      newUserClone[value.userProperty] = value.value;
      state.userProfileClone = newUserClone;
      // Check if there are difference in user and set if is updated
      state.userProfileCloneUpdated = !UtilsService.isEmpty(diff(state.userShowed, newUserClone));
      // All is like before no error are needed
      if (!state.userProfileCloneUpdated) {
        state.formPatchUserError = {};
      }
    },
    setIsActiveClone(state, value) {
      state.isActiveClone = value;
    },
    setUsers(state, data) {
      state.users = data;
    },
    setRolesEnumeration(state, value) {
      state.rolesEnumeration = value;
    },
    setProfileModalShow(state, value) {
      if (value === false) {
        state.formPatchUserError = [];
        state.formRolesUserError = [];
      }
      state.profileModalShow = value;
    },
    setFormRegisterError(state, value) {
      state.formRegisterError = value;
    },
    setFormPatchUserError(state, value) {
      state.formPatchUserError = value;
    },
    setFormRolesUserError(state, value) {
      state.formRolesUserError = value;
    },
    flushState(state) {
      state.users = null;
      state.userSession = null;
      state.userShow = null;
    },
    setShowUserSelectModal(state, value) {
      state.showUserSelectModal = value;
    },
  },
  getters: {
    getUserSession(state) {
      return state.userSession;
    },
    getUserShowed(state) {
      return state.userShowed;
    },
    getUserProfileClone(state) {
      return state.userProfileClone;
    },
    getUserProfileCloneUpdated(state) {
      return state.userProfileCloneUpdated;
    },
    getUserRolesClone(state) {
      return state.userRolesClone;
    },
    getUserRolesCloneUpdated(state) {
      return state.userRolesCloneUpdated;
    },
    getIsActiveClone(state) {
      return state.isActiveClone;
    },
    getUsers(state) {
      return state.users;
    },
    getRolesEnumeration(state) {
      return state.rolesEnumeration;
    },
    getProfileModalShow(state) {
      return state.profileModalShow;
    },
    getFormRegisterError(state) {
      return state.formRegisterError;
    },
    getFormPatchUserError(state) {
      return state.formPatchUserError;
    },
    getFormRolesUserError(state) {
      return state.formRolesUserError;
    },
    getShowUserSelectModal(state) {
      return state.showUserSelectModal;
    },
    isAdmin(state) {
      return AuthService.isGrantedSuperAdmin(state.userSession);
    },
    isAgent(state) {
      if (!state.userSession) {
        axios.get('/users/me')
          .then((response) => {
            return (response.data.roles.indexOf('ROLE_AGENT') !== -1)
          })
      } else {
        return (state.userSession.roles.indexOf('ROLE_AGENT') !== -1)
      }

      return false;
    },
    isAgency(state) {
      if (!state.userSession) {
        axios.get('/users/me')
          .then((response) => {
            return (response.data.roles.indexOf('ROLE_AGENCY') !== -1)
          })
      } else {
        return (state.userSession.roles.indexOf('ROLE_AGENCY') !== -1)
      }

      return false;
    }
  },
  actions: {
    getUserById(store, id) {
      axios.get(`users/${id}`)
          .then((response) => {
            return response.data;
          })
          .catch((error) => {
            console.error(error);
          });
    },
    getMe(store) {
      axios.get('users/me')
          .then((response) => {
            store.commit('setRolesEnumeration', getAppRolesEnum(response.data._embedded.roles_enumeration));
            store.commit('setUserSession', response.data);

            return response.data;
          })
          .catch((error) => {
            console.error(error);
          });
    },
    getUsers(store) {
      axios.get('users')
          .then((response) => {
            store.commit('setUsers', response.data);
          })
          .catch((error) => {
            console.error(error);
          });
    },
    resetPassword(store, form) {
      axios.post('users/reset/password', form)
          .then((response) => {
            return response.data.success;
          })
          .catch((error) => {
            console.error(error)
          });
    },
    logout(store) {
      AuthService.removeToken();
      store.commit('flushState');
      router.push('/');
    },
    register(store, form) {
      axios.post('users', form)
          .then((response) => {
            return response.data;
          })
          .catch((error) => {
            console.error(error);
          });
    },
    patchUser(store) {
      const patchObj = diff(store.state.userShowed, store.state.userProfileClone);

      if (!UtilsService.isEmpty(patchObj)) {
        axios.patch(`users/${store.state.userShowed.id}`, patchObj)
            .then((response) => {
              if (AuthService.isGrantedSuperAdmin(store.state.userSession)) {
                store.dispatch('getUsers');
              }

              return response.data;
            })
      } else {
        return store.state.userShowed;
      }
    },
    patchRoles(store) {
      axios.patch(`users/roles/${store.state.userShowed.id}`, { roles: store.state.userRolesClone })
          .then((response) => {
            if (AuthService.isGrantedSuperAdmin(store.state.userSession)) {
              store.dispatch('getUsers');
            }

            return response.data;
          })
          .catch((error) => {
            console.error(error);
          });
    },
    patchIsActive(store) {
      axios.patch(`users/is/active/${store.state.userShowed.id}`, { isActive: store.state.isActiveClone })
          .then((response) => {
            if (AuthService.isGrantedSuperAdmin(store.state.userSession)) {
              store.dispatch('getUsers');
            }

            return response.data;
          })
          .catch((error) => {
            console.error(error);
          });
    },
  },
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js